import DE from "country-flag-icons/react/1x1/DE";
import ES from "country-flag-icons/react/1x1/ES";
import FR from "country-flag-icons/react/1x1/FR";
import GB from "country-flag-icons/react/1x1/GB";
import IT from "country-flag-icons/react/1x1/IT";
import PT from "country-flag-icons/react/1x1/PT";
import SA from "country-flag-icons/react/1x1/SA";
import { CSSProperties } from "react";

/**
 * Map of ISO 3166-1 alpha-2 country codes to flag SVG components
 * Using 1x1 aspect ratio for consistency with emoji flags
 */
export const FLAGS = {
  GB,
  FR,
  DE,
  IT,
  ES,
  PT,
  SA,
} as const;

interface FlagIconProps {
  code: string;
  title?: string;
  style?: CSSProperties;
  className?: string;
}

/**
 * FlagIcon component renders cross-platform SVG flags
 * Replaces Unicode emoji flags that don't render on Windows
 *
 * @param code - ISO 3166-1 alpha-2 country code (e.g., "GB", "FR", "DE")
 * @param title - Accessible title for screen readers
 * @param style - CSS styles to apply
 * @param className - CSS class name
 * @returns SVG flag component or null if code not found
 *
 * @example
 * <FlagIcon code="GB" title="United Kingdom" style={{ width: 24, height: 24 }} />
 */
export const FlagIcon = ({ code, title, style, className }: FlagIconProps) => {
  const upperCode = code.toUpperCase() as keyof typeof FLAGS;
  const FlagComponent = FLAGS[upperCode];

  if (!FlagComponent) {
    console.warn(`FlagIcon: Flag not found for code: ${code}`);
    return null;
  }

  return (
    <FlagComponent aria-label={title} style={style} className={className} />
  );
};
